// Pages
export const HOME_PAGE_URL = '/';
export const ABOUT_PAGE_URL = '/about';
export const BOOKING_PAGE_URL = '/booking';
export const REVIEWS_PAGE_URL = '/reviews';
export const CONTACT_PAGE_URL = '/contact';
export const COMMERCIALS_PAGE_URL = '/commercials';
export const WELLNESS_PAGE_URL = '/wellness';

// Terms and Conditions
export const POLICIES_PAGE_URL = '/user-agreements';

// Maintainance
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';

// Error
export const ERROR_404_PAGE_URL = '*';

// User pages
export const LOGIN_PAGE_URL = '/login';
export const RESET_PASS_PAGE_URL = '/reset-password';

// Admin pages
export const CONTACT_ADMIN_PAGE_URL = '/admin/contact-forms';
export const BOOKING_ADMIN_PAGE_URL = '/admin/booking-admin';

// Booking routes
